import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { forkJoin } from 'rxjs';
import { ConfigService } from 'src/app/service/config.service';
import { UserSettingsApiService } from 'src/app/shared/services/customer-api/user-settings-api.service';
import { WhatsNew } from 'src/app/shared/models/whats-new.interface';
import { DialogWhatsNewComponent } from 'src/app/micro-components/dialog-whats-new/dialog-whats-new.component';

const SEEN_VERSION_KEY = 'whatsNewSeenVersion';

@Injectable({ providedIn: 'root' })
export class WhatsNewService {
  constructor(
    private http: HttpClient,
    private dialog: MatDialog,
    private config: ConfigService,
    private userSettingsApi: UserSettingsApiService,
  ) {}

  check(): void {
    if (!this.config.appConfig.setup.useStorage) {
      return;
    }
    forkJoin([
      this.http.get<WhatsNew>('assets/whats-new.json'),
      this.userSettingsApi.getUserSettings(SEEN_VERSION_KEY),
    ]).subscribe({
      next: ([whatsNew, seen]) => this.maybeShow(whatsNew, seen?.entry),
      // No notes shipped with this build, or the seen-version fetch failed —
      // never risk re-announcing, show nothing
      error: () => undefined,
    });
  }

  private maybeShow(whatsNew: WhatsNew, seenVersion?: string): void {
    if (!whatsNew?.version || !whatsNew.items?.length) {
      return;
    }
    if (seenVersion === whatsNew.version) {
      return;
    }
    this.dialog
      .open(DialogWhatsNewComponent, {
        data: whatsNew,
        width: '520px',
        maxWidth: '92vw',
        panelClass: 'whats-new-dialog',
        autoFocus: false,
      })
      .afterClosed()
      .subscribe(() =>
        this.userSettingsApi
          .setUserSettings(SEEN_VERSION_KEY, whatsNew.version)
          .subscribe(),
      );
  }
}
